import {getShortlistDataAjax, showToast} from './core';
import {fromJS} from 'immutable';

export const addToShortlist = (id) => {
    return {
        type: 'ADD_TO_SHORTLIST',
        payload: {id}
    };
};

export const removeFromShortlist = (id) => {
    return {
        type: 'REMOVE_FROM_SHORTLIST',
        payload: {id}
    };
};

export const addToShortlistAsync = (id) => {
    return dispatch => {
        dispatch(addToShortlist(id));
        showToast();
        dispatch(populateShortlistAsync());
    };
};

export const removeFromShortlistAsync = (id) => {
    return dispatch => {
        dispatch(removeFromShortlist(id));
        showToast(true);
        dispatch(populateShortlistAsync());
    };
};

export const setShortlistData = shortlistData => {

    return {
      type: 'SET_SHORTLIST_DATA',
      payload: {shortlistData}
    };
};

export const populateShortlistAsync = () => {
  return (dispatch, getState) => {
      const shortlist = getState().getIn(['shortlistSideMenu', 'shortlist']);
      //console.log(shortlist);
      getShortlistDataAjax(shortlist)
        .then(res => {
              const shortlistData = fromJS(JSON.parse(res.text));
              dispatch(setShortlistData(shortlistData));
          })
          .catch(err => {
              console.error(err);
          });
  };
};
